import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
import { useUiTranslations } from "@/hooks/use-ui-translations";

interface DateFilterProps {
  selected: Date | null;
  onSelect: (date: Date | null) => void;
}

export function DateFilter({ selected, onSelect }: DateFilterProps) {
  const { t } = useUiTranslations();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={`shrink-0 inline-flex items-center gap-1.5 rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
            selected
              ? "border-primary bg-primary text-primary-foreground"
              : "border-border bg-card text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          }`}
        >
          <CalendarDays className="h-3.5 w-3.5" />
          {selected ? format(selected, "d MMM") : t("filter.date")}
          {selected && (
            <X
              className="ml-0.5 h-3 w-3"
              onClick={(e) => {
                e.stopPropagation();
                onSelect(null);
              }}
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected ?? undefined}
          onSelect={(d) => {
            onSelect(d ?? null);
            setOpen(false);
          }}
          disabled={(d) => d < new Date(new Date().setHours(0, 0, 0, 0))}
        />
      </PopoverContent>
    </Popover>
  );
}
